exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700,800,900&display=swap);", ""]);

// module
exports.push([module.id, ".Uitleg-Module__pagewrapper___2svbs{display:grid;grid-template-columns:210px 1fr;min-height:calc(100vh - 80px)}.Uitleg-Module__pagewrapper___2svbs .Uitleg-Module__wrapper___2Kd9x{padding:50px;max-width:800px}.Uitleg-Module__pagewrapper___2svbs a{font-weight:700;color:#333860}@media only screen and (max-width:800px){.Uitleg-Module__pagewrapper___2svbs{grid-template-columns:1fr!important}}", ""]);

// exports
exports.locals = {
	"pagewrapper": "Uitleg-Module__pagewrapper___2svbs",
	"wrapper": "Uitleg-Module__wrapper___2Kd9x"
};